import { OnboardingProvideObject } from "@/types/onboarding";
import { getInjectionKey } from "../app";

export const onboardingInjectionKey =
  getInjectionKey<OnboardingProvideObject>();
